import { ValidationResult } from '@/shared/validation/types';

export default function getValidationResult(condition: boolean, message: string): ValidationResult {
    return condition || message;
}
